module.exports = __webpack_public_path__ + "img/banner_082403.8439be79.png";